const timeline = [
  { date: '1953', position: 'year' },
  {
    date: '1953',
    content:
      'Arthur C. Clarke  <strong>The Nine Billion Names of God</strong> is published.',
    position: 'left'
  },
  { date: '1954', position: 'year' },
  {
    date: 'January 1954',
    content:
      "Brion Gysin and William S. Burroughs frst meet at an exhibition of Gysin's paintings of the Saharah.",
    position: 'right'
  },
  {
    date: '1954',
    content:
      "First edition of Aldous Huxley's <strong>Doors Of Perception</strong> published (does not include <strong>Heaven and Hell</strong>).",
    position: 'left'
  },
  {
    date: 'December 1954',
    content:
      'Gysin opens a restaurant called <strong>The 1001 Nights</strong> in the narrow wing of the Menehbi Palace on the Marsham in Tangier.',
    position: 'right'
  },
  { date: '1955', position: 'year' },
  {
    date: '1955',
    content:
      'The RAND Coproration publishes <strong>A Million Random Digits with 100,000 Normal Deviates</strong>.',
    position: 'left'
  },
  { date: '1956', position: 'year' },
  {
    date: '1956',
    content:
      'Brion Gysin finds a curse in the form of a magic word square in the vent of the restaurant he runs in Tangiers.',
    position: 'right'
  },
  {
    date: 'August 1956',
    content: "Gysin's restaurant closes.",
    position: 'right'
  },
  {
    date: '1956',
    content:
      "Aldous Huxley's <strong>Heaven and Hell</strong> essay is published in the second edition of  <strong>Doors Of Perception</strong></a>.",
    position: 'left'
  },
  {
    date: '1956',
    content:
      'The Tompkins-Paige permutation algorithm is outlined in the paper <strong>Machine attacks on problems whose variables are permutations</strong> in <strong>Proceedings of the  Symposium in Applied Mathematics: Numerical Analysis Vol. 6 </strong>',
    position: 'left'
  },
  { date: '1957', position: 'year' },
  {
    date: '1957',
    content:
      '<strong>material: kleine antologie konkrete dichtung</strong> published by the "Darmstadt Circle" of poets.  It features Daniel Spoerri\'s <strong>das rezel kroitz wort</strong> and <strong>erst lezt das erste</strong>.',
    position: 'right'
  },
  {
    date: '1957',
    content: 'IBM releases the first version of FORTRAN for the 704 computer.',
    position: 'left'
  },
  { date: '1958', position: 'year' },
  {
    date: 'January 1958',
    content:
      'The first issue of the monthly journal <strong>Communications of the ACM</strong> is published.',
    position: 'left'
  },
  {
    date: '11 July 1958',
    content:
      'At Cambridge University, the EDSAC 1 computer is shut down and replaced by EDSAC 2, the first full-scale microprogrammed machine.',
    position: 'left'
  },
  {
    date: 'Autumn 1958',
    content:
      'Gysin returns to Paris and moves into the Beat Hotel (9, rue Git-le-Coeur) with William S. Burroughs.',
    position: 'right'
  },
  {
    date: '1958',
    content:
      'Gysin writes <strong>I AM THAT I AM</strong> (without computer assistance).',
    position: 'right'
  },
  {
    date: '1958',
    content:
      "Jackson Mac Low obtains a copy of The RAND Coproration's  <strong>A Million Random Digits with 100,000 Normal Deviates</strong> and starts using it heavily in his work.",
    position: 'right'
  },
  {
    date: '1958',
    content: 'The programming language FORTRAN II is released.',
    position: 'left'
  },
  { date: '1959', position: 'year' },
  {
    date: 'Summer 1959',
    content:
      "An 18-year-old Ian Sommerville was stays in Paris in order to improve his French before starting a course in mathematics at Cambridge University's Corpus Christi College.",
    position: 'right'
  },
  {
    date: 'Autumn 1959',
    content:
      'Ian Sommerville starts studying Mathematics at Corpus Christi College, Cambridge University.',
    position: 'right'
  },
  {
    date: 'Late December 1959',
    content:
      'Burroughs first sends the first version of the manuscript of the book <strong>The Exterminator</strong> to the publisher Dave Haselwood.',
    position: 'right'
  },
  { date: '1960', position: 'year' },
  {
    date: 'March 1960',
    content:
      '<strong>Minutes To Go</strong> by Sinclair Beiles, William S. Burroughs, Gregory Corso and Brion Gysin published by Two Cities in an edition of 1,000 copies.  It is launched with a party at the English Bookshop in Paris on 13 April 1960.',
    position: 'right'
  },
  {
    date: 'Early 1960',
    content:
      'George Macbeth, Director of Talks for the BBC Third Programme reads <strong>Minutes To Go</strong> and contacts Gysin about creating a radio programme. ',
    position: 'right'
  },
  {
    date: 'July 1960',
    content:
      "<strong>The Exterminator</strong> by William S. Burroughs and  Brion Gysin published by Dave Haselwood's Auerhahn Press in San Francisco.",
    position: 'right'
  },
  {
    date: 'Summer 1960',
    content:
      "Recording of <strong>The Permutated Poems of Brion Gysin</strong> radio programme over two days at the BBC in Sheperd's Bush, London.",
    position: 'right'
  },
  {
    date: '1960',
    content: `<strong>PERMUTATION ALGORITHMS PUBLISHED</strong> in D H. Lehmer "Teaching combinatorial tricks to a computer," and R. J. Walker "An Enumerative Techniqe for a Class of Combinatorial Problem" in <i>Proceedings of Symposium Applied Mathematics,Combinatorial Analysis</i>, Vol. 10.  This contained:
      <br>Lehmer Constant Difference Method 
      <br>A previously unpublished method by Marshall Hall Jr.
      <br>Walker Backtrack Method`,
    position: 'left'
  },
  { date: '1961', position: 'year' },
  {
    date: '1961',
    content:
      "Publication of Jorge Louis Borges's short story <strong>The Library of Babel</strong> in French.",
    position: 'left'
  },
  {
    date: '1961',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> M. B. Wells "Generation of permutations by transposition" in <i>Mathematics of Computation</i> 15.',
    position: 'left'
  },
  {
    date: 'March 1961',
    content:
      'Brion Gysin writes to BBC producer Douglas Cleverdon to ask about delay of the broadcast of <strong>The Permutated Poems of Brion Gysin</strong> radio programme.',
    position: 'right'
  },
  {
    date: 'April 1961',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> R. R. Coveyou & J. G. Sullivan in "Algorithm 71: permutation" in <i>Communications of the ACM</i> 4',
    position: 'left'
  },
  {
    date: '15 August 1961',
    content:
      "22:00 - Broadcast of <strong>The Permutated Poems of Brion Gysin</strong> on BBC's Third Programme.",
    position: 'right'
  },
  { date: '1962', position: 'year' },
  {
    date: 'April 1962',
    content: `<strong>PERMUTATION ALGORITHMS PUBLISHED</strong> 
      <br>J. E. L. Peck and G. F. Schrack "Algorithm 86: Permute" <i>Communications of the ACM</i>
      <br>John R. Howell "Algorithm 87: Permutation generator" <i>Communications of the ACM</i>      `,
    position: 'left'
  },
  {
    date: 'June 1962',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> G. F. Schrack and M. Shimrat "Permutation in lexicographic order (Algorithm 102)," <i>Communications of the ACM</i> 5, 6.',
    position: 'left'
  },
  {
    date: 'August 1962',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> H. F. Trotter "Perm (Algorithm 115)," in <i>Communications of the ACM</i> 5, 8',
    position: 'left'
  },
  {
    date: 'November 1962',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> B. C. Eaves "Algorithm 130: Permute" <i>Communications of the ACM<i> 5, 11',
    position: 'left'
  },
  {
    date: 'December 1962',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> M. K. Shen "On the generation of permutations and combinations", <i>BIT</i> Vol. 2: 4',
    position: 'left'
  },
  {
    date: '1962',
    content:
      "Two translations of Jorge Louis Borges's short story <strong>The Library of Babel</strong> appear in English.",
    position: 'left'
  },
  {
    date: '1962',
    content:
      "Publication of issue number 8 of the magazine <strong>rot</strong>, a journal of the Stuttgart School of Information Aesthetics.  This issue featured       Abraham A. Moles's artice <strong>erstes manifest der permutationellen kunst</strong> or <strong>First manifesto of a permutationall art</strong>.",
    position: 'left'
  },
  { date: '1963', position: 'year' },
  {
    date: 'July 1963',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> S.M. Johnson in the article "Generation of permutations by adjacent transposition" in <i>Mathematics of Computation</i> 17, 83.  [Steinhaus-Trotter-Johnson]',
    position: 'left'
  },

  {
    date: 'July 1963',
    content:
      'The Loughborough Bell Foundry in Leicestershire, England ring out all 40,320 possible permutations of eight church bells in a performance lasting nearly a full day.',
    position: 'right'
  },
  {
    date: 'September 1963',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> M. K. Shen in the article "Generation of permutations in lexicographic order (Algorithm 202)," in <i>Communications of the ACM</i> 6, 9 [lexicographic].',
    position: 'left'
  },
  {
    date: '9 September 1963',
    content:
      "First performance of Jackson Mac Low's <strong>JAIL BREAK</strong> at a Poet's Reading at Living Theatre, New York.",
    position: 'right'
  },
  {
    date: 'November 1963',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> B R. Heap in the paper "Permutations by Interchanges" in <i>The Computer Journal</i>.',
    position: 'left'
  },
  {
    date: '1963',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> H. Steinhaus in the book <i>One Hundred Problems in Elementary Mathematics</i>, Pergamon Press [Steinhaus-Trotter-Johnson]',
    position: 'left'
  },
  {
    date: '1963',
    content:
      "<strong>An Anthology Of Chance Operations</strong> published, featuring Emmett Williams' <strong>Cellar Song for Five Voices</strong>.",
    position: 'right'
  },
  { date: '1964', position: 'year' },
  {
    date: 'April 1964',
    content: 'Gysin leaves the Beat Hotel for Tangier.',
    position: 'right'
  },
  {
    date: 'July 1964',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> Richard Durstenfeld "Algorithm 235: random permutation" <i>Communications of the ACM</i>',
    position: 'left'
  },
  {
    date: '8 December 1964',
    content:
      'Burroughs arrives in New York. Gysin is already there.  They meet most days at 9:30a.m to work on the book <strong>The Third Mind</strong> over a period of months, first in Burroughs’ room at the Chelsea Hotel, and later at a loft he moved into at 210 Center Street.',
    position: 'right'
  },
  {
    date: '1964',
    content:
      '<strong>PERMUTATION ALGORITHMS PUBLISHED</strong> "The year 1964 turned out to be an important year for permutation sequence generators, in general, and random permutation sequence generators , in particular.  First Sag intrduced an algorithm to generate all permutations of a set with repetitions.  Second, Durstenfeld put forth procedure SHUFFLE that generates random permutations of sequence {1,2, ... <i>n</i>}.  The procedure by Durstenfeld was based on the shuffling method first described by Fischer and Yates in <i>Statistical Tables for Biological, Agricultural and Medical Research</i> in 1938..." <br> Kenneth J. Berry, Janis E. Johnston, Paul W. Mielke Jr <i>A Chronicle of Permutation Statistical Methods: 1920–2000, and Beyond</i> (2014) Springer, London, p. 213',
    position: 'left'
  },
  { date: '1965', position: 'year' },
  {
    date: 'August 1965',
    content:
      "Jackson Mac Low's <strong>JAIL BREAK</strong> is published in <i>Workshop in Nonviolence</i> Vol. II Nos. 14 and 15.",
    position: 'right'
  },

  {
    date: 'Winter 1965',
    content:
      'The composer James Tenney holds a workshop in programming FORTRAN for his artistic friends in New York, including Phil Corner, Jackson Mac Low, Max Neuhaus, Nam June Paik, Steve Reich, Alison Knowles and Dick Higgins.',
    position: 'left'
  },
  {
    date: '1965',
    content: 'The Honeywell 200 Model 120 is released.',
    position: 'left'
  },
  {
    date: '1965',
    content:
      'The article "Combinatorial Analysis and Computers" by Marshall Hall and Donald Knuth is published.',
    position: 'left'
  },
  {
    date: '1965',
    content:
      "The book <i>Applied Combinatorial Mathematics</i> by E.F. Beckenbach is published. This contains D. H. Lehmer's article <i>Machine tools of Computation</i>",
    position: 'left'
  },
  {
    date: '1965',
    content:
      'Emmett Williams uses an IBM computer to produce his poem <strong>Music</strong>.',
    position: 'left'
  },
  {
    date: '1965',
    content:
      "William S. Burroughs, Ian Sommerville & Brion Gysin's book <strong>The Third Mind</strong> is finished but not published.",
    position: 'right'
  },
  { date: '1966', position: 'year' },
  { date: '1967', position: 'year' },
  {
    date: 'July 1967',
    content:
      'George Perec visits the University of Michigan and sees their computers.',
    position: 'right'
  },
  {
    date: '1967',
    content:
      '<strong>PERMUTATION ALGORITHMS PUBLISHED</strong> <br>Langdon, <br>Phillips (BCJ28), <br>Boothroyd (BCJ29/30).',
    position: 'left'
  },
  {
    date: '1967',
    content:
      "<strong>Anthology of Concrete Poetry</strong> edited by Emmett Williams is published.  Contains a version of <strong>I AM THAT I AM</strong>, Jackson Mac Low's  JAIL BREAK and Daniel Spoerri's <strong>das rezel kroitz wort</strong> and <strong>erst lezt das erste</strong>.",
    position: 'right'
  },
  { date: '1968', position: 'year' },
  {
    date: 'February 1968',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> Ord-Smith [Reverse Lexicographic] (ACM323: BESTLEX).',
    position: 'left'
  },
  {
    date: '1968',
    content:
      "Volume 1 of Donald Knuth's <strong>The Art of Computer Programming</strong> is published.",
    position: 'left'
  },
  {
    date: '1968',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> Ord-Smith [Pseudo-Lexicographic].',
    position: 'left'
  },
  { date: '1969', position: 'year' },
  {
    date: 'Summer 1969',
    content:
      'Jackson Mac Low generates his first computer poems while resident at the Los Angeles County Musem.',
    position: 'right'
  },
  { date: '1970', position: 'year' },
  {
    date: 'May 1970',
    content:
      'The overview article "Generation of permutation sequences: Part 1" by R. J. Ord-Smith is published <i>The Computer Journal</i> 13, 2.',
    position: 'left'
  },
  { date: '1971', position: 'year' },
  {
    date: 'February 1971',
    content:
      'The overview article "Generation of permutation sequences: Part 2" by R. J. Ord-Smith is published <i>The Computer Journal</i> 13, 2.',
    position: 'left'
  },
  { date: '1972', position: 'year' },
  {
    date: '1972',
    content:
      'The poem <strong>THIS IS SAM FRANCIS</strong> is published in the exhibition catalogue for <strong>Sam Fancis, Paintings, 1947-1972</strong>.',
    position: 'right'
  },
  { date: '1973', position: 'year' },
  {
    date: '1973',
    content:
      'The book <strong>Brion Gysin Let The Mice In</strong> is published.',
    position: 'right'
  },
  { date: '1974', position: 'year' },
  { date: '1975', position: 'year' },
  {
    date: 'January 1975',
    content:
      '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> C. T. Fike "A permutation generation method" <i>The Computer Journal</i> 18, 1.',
    position: 'left'
  },
  { date: '1976', position: 'year' },
  {
    date: '5 February 1976',
    content: 'Ian Sommerville is killed in a car accident at the age of 36.',
    position: 'right'
  },
  {
    date: 'May 1976',
    content:
      'J. S. Rohl "Programming Improvements to Fike\'s Algorithm for Generating Permutations" <i>The Computer Journal</i> 19, 2.',
    position: 'left'
  },
  {
    date: '1976',
    content: '<strong>PERMUTATION ALGORITHM PUBLISHED</strong> Ives.',
    position: 'left'
  },
  {
    date: '1976',
    content:
      'The French translation of <strong>The Third Mind</strong> is published.',
    position: 'right'
  },
  { date: '1977', position: 'year' },
  {
    date: 'January 1977',
    content:
      'The overview article "Generation of Permutation Sequences" is published by A. D. Woodall <i>The Computer Journal</i> 20, 4.',
    position: 'right'
  },
  {
    date: 'June 1977',
    content:
      'The overview article "Permutation Generation Methods" by R. Sedgewick is published in <i>ACM Computer Survey</i> 9, 2.',
    position: 'left'
  },
  { date: '1978', position: 'year' },
  {
    date: 'January 1978',
    content:
      'The overview article "Evaluation of permutation algorithms" by M. K. Roy is published in <i>The Computer Journal</i> 21, 4.',
    position: 'left'
  },
  {
    date: '1978',
    content:
      'The English version of <strong>The Third Mind</strong> is published by Viking.',
    position: 'right'
  },
  { date: '1979', position: 'year' },
  { date: '1980', position: 'year' },
  { date: '1981', position: 'year' },
  {
    date: '1981',
    content:
      'The album <strong>Songs</strong> by Steve Lacy and Brion Gysin is released.',
    position: 'right'
  },
  { date: '1982', position: 'year' },
  {
    date: 'January 1982',
    content:
      'The overview article "Functional Programs for Generating Permutations" by R. W. Topor is published in <i>The Computer Journal</i> 25, 2.',
    position: 'left'
  },
  {
    date: '1982',
    content: 'The album <strong>Orgy Boys</strong> is released.',
    position: 'right'
  }
];

export default timeline;
